import React, { Fragment } from "react";
import { Text } from "blueprints2";
import { FormattedMessage } from "react-intl";

function MigrateAppsList({
  noApps,
  applications: apps,
  isMigrated,
  stepThree,
}) {
  return (
    <Fragment>
      {isMigrated && !stepThree && (
        <p className="guide-heading">
          <FormattedMessage id="migrate.apps.done" />
        </p>
      )}
      {noApps && (
        <p className="guide-heading">
          <FormattedMessage id="migrate.apps.none" />
        </p>
      )}
      {!isMigrated && !noApps && (
        <div>
          <FormattedMessage id="migrate.apps.heading" />
          <div className="applications-list">
            {apps &&
              apps.map((application, index) => {
                return <Text key={index}>{application.name}</Text>;
              })}
          </div>
          <Text className="guide-heading">
            <FormattedMessage id="migrate.apps.total" /> {apps?.length}
          </Text>
        </div>
      )}
    </Fragment>
  );
}

export default MigrateAppsList;
